import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { Printer, ChefHat } from "@phosphor-icons/react";
import { printNode, buildKOTHTML } from "@/lib/print";

export default function KOTDialog({ data, settings, onClose }) {
  if (!data) return null;
  const { order, kot_batch, kot_items } = data;
  if (!kot_batch || !kot_items?.length) return null;
  const date = new Date(kot_batch.printed_at);

  const handlePrint = () => {
    printNode(buildKOTHTML(data, settings), `KOT #${kot_batch.kot_number}`);
  };

  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm p-0 overflow-hidden" data-testid="kot-dialog">
        <div className="p-6 max-h-[80vh] overflow-y-auto font-mono text-base print-target" id="kot-print">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-stone-500 font-mono">
              <ChefHat size={14} weight="duotone" /> Kitchen Order
            </div>
            <div className="font-display text-3xl font-black tracking-tight mt-1">{settings?.outlet_name || "Hizli"}</div>
          </div>
          <div className="border-t-2 border-dashed border-stone-400 my-3"></div>
          <div className="flex justify-between text-sm">
            <span className="font-bold">KOT #{kot_batch.kot_number}</span>
            <span className="text-stone-600">{date.toLocaleTimeString()}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span>Order #{order.order_number}</span>
            <span className="text-stone-600">Seq {kot_batch.seq}</span>
          </div>
          <div className="text-xs text-stone-500 mt-1">Staff: {order.staff_name}</div>
          <div className="border-t-2 border-dashed border-stone-400 my-3"></div>

          {kot_items.map((it, i) => (
            <div key={i} className="mb-4 pb-3 border-b border-dashed border-stone-200">
              <div className="flex justify-between font-bold text-lg leading-tight">
                <span>{it.quantity}× {it.name}</span>
              </div>
              <div className="text-sm text-stone-700 pl-2 mt-1">
                {it.size && <>{it.size}</>}{it.sugar ? ` · Sugar ${it.sugar}` : ""}{it.ice ? ` · Ice ${it.ice}` : ""}
              </div>
              {it.toppings?.length > 0 && (
                <div className="text-sm text-stone-700 pl-2 mt-0.5">
                  + {it.toppings.map((t) => t.name).join(", ")}
                </div>
              )}
              {it.notes && (
                <div className="text-sm font-semibold text-stone-900 pl-2 mt-1 italic">
                  ✱ {it.notes}
                </div>
              )}
            </div>
          ))}

          <div className="border-t-2 border-dashed border-stone-400 mt-3 pt-3 text-center text-xs uppercase tracking-widest text-stone-500">
            — Prepare these items —
          </div>
        </div>
        <div className="p-3 border-t border-boba-stoneLine bg-boba-cream flex gap-2 no-print">
          <button
            onClick={handlePrint}
            className="flex-1 h-11 bg-white border border-boba-stoneLine rounded-md font-medium text-sm hover:bg-stone-50 flex items-center justify-center gap-2"
            data-testid="kot-print"
          >
            <Printer size={18} /> Print KOT
          </button>
          <button
            onClick={onClose}
            className="flex-1 h-11 bg-boba-matcha hover:bg-boba-matchaDark text-white rounded-md font-medium text-sm"
            data-testid="kot-done"
          >
            Done
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
